// src/lib/resa-month-overrides.js — Lot 3 V2-move-resa
//
// Helpers PURS pour le store GLOBAL de déplacement de mois d'une résa V2 :
//   data._monthOverrides[lid] = { [codeStable]: 'YYYY-MM' }
//
// Miroir de src/lib/resa-tombstones.js (même esprit : store global par logement,
// indexé par code stable airbnbCode || bookingRef). La projection
// (collectMonthOverrides + applyMonthMoves dans data-projection.js) relit ce
// store à CHAQUE render et ré-impute la résa à son mois cible. Beds24 = source
// brute jamais modifiée. Ces helpers MUTENT `nd` (deep clone géré par l'appelant,
// comme deleteResaV2 / saveMontantOverride).

// ── setMonthOverride(nd, lid, code, mk) ──
// Pose/écrase data._monthOverrides[lid][code] = mk. Garde défensive : nd objet,
// lid + code + mk 'YYYY-MM' requis (sinon no-op).
export function setMonthOverride(nd, lid, code, mk) {
  if (!nd || typeof nd !== 'object') return
  if (!lid || !code) return
  if (typeof mk !== 'string' || !/^\d{4}-\d{2}$/.test(mk)) return
  if (!nd._monthOverrides) nd._monthOverrides = {}
  if (!nd._monthOverrides[lid] || typeof nd._monthOverrides[lid] !== 'object') {
    nd._monthOverrides[lid] = {}
  }
  nd._monthOverrides[lid][code] = mk
}

// ── removeMonthOverride(nd, lid, code) ──
// Retire data._monthOverrides[lid][code] (retour au mois naturel) + cleanup de
// l'objet lid vide. No-op défensif si absent.
export function removeMonthOverride(nd, lid, code) {
  if (!nd || typeof nd !== 'object') return
  if (!lid || !code) return
  const store = nd._monthOverrides
  if (!store || typeof store !== 'object') return
  const lidMap = store[lid]
  if (!lidMap || typeof lidMap !== 'object') return
  if (Object.prototype.hasOwnProperty.call(lidMap, code)) {
    delete lidMap[code]
    if (Object.keys(lidMap).length === 0) delete store[lid]
  }
}
